import { Content } from '@orobix/orobix-fe-components'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { withQueryErrorBoundary } from '../../components/QueryErrorBoundary/withQueryErrorBoundary'
import { BulkUploadButton } from './BulkUploadButton'
import { DrugRegistryList } from './DrugRegistryList/DrugRegistryList'

export const DrugRegistryRoot = withQueryErrorBoundary(() => (
  <Content>
    <PageHeader title="" right={<BulkUploadButton />} />
    <DrugRegistryList />
  </Content>
))
